import React, {Component, Fragment, h, options} from "preact";
import {Field} from 'react-final-form';
import {Answer, Question} from "../../_api";
import {C, FR} from "../../_common/layout";
import {t} from "../../_i18n";
import {validateClosedQuestion, showErrorClosed } from "../validateOfferEdit"

const GradeOptions = [
 {key:"", name:"", value:null}
,{key:"-1", name:t("Descartar"), value:-1}
,{key:"0", name:"0", value:0}
,{key:"1", name:"1", value:1}
,{key:"2", name:"2", value:2}
,{key:"3", name:"3", value:3}
,{key:"4", name:"4", value:4}
,{key:"5", name:"5", value:5}
,{key:"6", name:"6", value:6}
,{key:"7", name:"7", value:7}
,{key:"8", name:"8", value:8}
,{key:"9", name:"9", value:9}
,{key:"10", name:"10", value:10}
];

export class ClosedQuestionEditor extends Component<any, any>{

    changeAnswerText(question: Question, answer: Answer, text: string, input:any){
        answer.text = text;
        input.onChange(answer)
        this.props.onChange();
    }

    changeAnswerGrade(question: Question, answer: any, grade: any, input:any){
        answer.grade = grade ? parseInt(grade) : null;
        input.onChange(answer)
        this.props.onChange();
    }

    changeQuestion(question: Question, text: string, input: any){
        question.text = text;
        input.onChange(question)
        this.props.onChange();
    }

    render({questions, addQuestion, deleteQuestion, disabled}:any){
        return <Fragment>
            {questions && questions.map((question:any)=>{
                return <Field
                    name={question.id.toString()+'_'}
                    validate={() => validateClosedQuestion(question)}
                >
                    {({input, meta}) =>
                        <div className={`card card-level2 p-top p-bottom m-bottom ${showErrorClosed(meta) && 'border-red'}`} key={question.id}>
                            <C>
                                <FR className="flex-center-y">
                                    <div className="col-100 no-margin-bottom d-flex flex-space-between">
                                        <span className="font-18"><b>{t('Pregunta')}</b></span>
                                        { !disabled && <span className="font-26 cursor-pointer " onClick={()=>deleteQuestion(question)}><i className="fal fa-times font-color-soft-gray" /></span>}
                                    </div>
                                    <div className="col-100">
                                        <input className='form-control' type="text" value={question.text} onChange={(e:any)=>this.changeQuestion(question, e.target.value, input)} disabled={disabled}/>
                                        {/*<FormField label={'Pregunta'} name={"Pregunta"+question.id.toString()} specificError="Por favor, introduce una pregunta" required onChange={(e:any)=>this.changeQuestion(question, e)}/>*/}
                                    </div>
                                </FR>
                                <FR>
                                    <div className="sm-col-80 d-none sm-d-block no-margin-bottom">
                                        <span className={"font-18"}><b>{t('Respuestas')}</b> ({t('mínimo 2 respuestas')})</span>
                                    </div>
                                    <div className="col-75 sm-d-none no-margin-bottom d-flex flex-column">
                                        <span className={"font-18"}><b>{t('Respuestas')}</b></span>
                                        <span className={"font-18"}>({t('mínimo 2 respuestas')})</span>
                                    </div>
                                    <div className="sm-col-20 d-none sm-d-block no-margin-bottom"><span className={"font-18"}><b>{t('Puntuación')}</b></span></div>
                                    <div className="col-25 d-block sm-d-none no-margin-bottom"><span className={"font-18"}><b>{t('Pnts.')}</b></span></div>
                                </FR>

                                {question.answers?.map((answer:Answer)=> <FR key={answer.id} className="flex-center-y flex-space-between">
                                    <div className="sm-col-75 col-70">
                                        <input className='full-width form-control' type="text" value={answer.text} onChange={(e:any)=>this.changeAnswerText(question, answer, e.target.value, input)} disabled={disabled}/>
                                        {/*<FormField label={'Respuesta'} name={"Respuesta"+answer.id} specificError="Por favor, introduce una respuesta" required onChange={(e:any)=>this.changeAnswerText(answer, e)}/>*/}
                                    </div>
                                    <div className="sm-col-20 col-25">
                                        <div className='form-group no-margin-bottom'>
                                            <select className='full-width form-control' value={answer.grade} onChange={(e:any)=>this.changeAnswerGrade(question, answer, e.target.value, input)} disabled={disabled}>
                                                {
                                                    GradeOptions.map((grade: any) => <option value={grade.value}>{grade.name}</option>)
                                                }
                                            </select>
                                            <i className="far fa-angle-right" />
                                        </div>
                                    </div>
                                </FR> )}
                                {(showErrorClosed(meta)) && <div className='m-top font-18 font-color-red'>{meta.error}</div>}
                            </C>
                        </div>
                    }
                </Field>

                }


            )}
            <br/>
            { !disabled && <a className="cursor-pointer text-primary font-18" onClick={addQuestion}>+ <span className='t-underline'>{t('Añadir pregunta cerrada')}</span></a>}
        </Fragment>
    }
}
